// =========== WISH.LUX / SUBSCRIPTIONS CUSTOM SCRIPTS ===================

// Change the text for the product and policy
const subRenewalText =  document.querySelector(".group_list_item > .title_and_price_wrapper > span");
subRenewalText.textContent = "Annual Subscription";

const subPolicyText =  document.querySelector(".shopify_subscriptions_app_policy");
subPolicyText.textContent = "Auto-renews annually.";